export default {
  paged: {
    select:
      'id,type,originalAmount,remainingAmount,currency,validFrom,expiresAt,isActive,reason,created,creator',
    orderBy: 'created desc',
  },
};
